__turbopack_context__.v({
  "errorText": "ageCalc-module__0B87wG__errorText",
  "formCard": "ageCalc-module__0B87wG__formCard",
  "formRow": "ageCalc-module__0B87wG__formRow",
  "gst-result-box": "ageCalc-module__0B87wG__gst-result-box",
  "labelRow": "ageCalc-module__0B87wG__labelRow",
  "mainAge": "ageCalc-module__0B87wG__mainAge",
  "results": "ageCalc-module__0B87wG__results",
  "setTodayBtn": "ageCalc-module__0B87wG__setTodayBtn",
  "statCard": "ageCalc-module__0B87wG__statCard",
  "statLabel": "ageCalc-module__0B87wG__statLabel",
  "statSub": "ageCalc-module__0B87wG__statSub",
  "statValue": "ageCalc-module__0B87wG__statValue",
  "statsGrid": "ageCalc-module__0B87wG__statsGrid",
  "text-alignment": "ageCalc-module__0B87wG__text-alignment",
  "wrapper": "ageCalc-module__0B87wG__wrapper",
});
